export default __webpack_public_path__ + "static/media/lb.2d5ab800.svg";